import * as React from 'react';

import { Address, Recipient } from 'api/api';

import { bootstrapConfig } from '~src/context/config';
import { FullscreenComponent, FullscreenMode } from '~src/fullscreen-internals/fullscreen-mode';
import { Dialog } from '~src/ui/dialog';

import { BillingAddressListFSM } from '~address-form/address-list/billing-address-list-fsm';

import { ExtendedValidationHandler } from '../state-machines/shared-types';
import { BillingFormFullscreenFSM } from './billing-form-fullscreen-fsm';

interface BillingFormModalProps {
  triggerExtendedValidation: ExtendedValidationHandler;
  step: 'list' | 'form';
  handleClose: () => void;
  handleSubmit: (address: Recipient) => void;
  handleDelete: (address: Recipient) => void;
  handleAddNewAddress: (address: Recipient) => void;
  handleOpenAddress: (address: Recipient) => void;
  extendedAddress?: Address;
  setExtendedAddress: React.Dispatch<React.SetStateAction<Address | undefined>>;
}

export const BillingFormModal: FullscreenComponent<BillingFormModalProps> = ({
  step,
  handleClose,
  handleAddNewAddress,
  handleOpenAddress,
  extendedAddress,
  setExtendedAddress,
  ...props
}) => {
  if (step === 'list') {
    return (
      <Dialog height={770} width={520} onClose={handleClose}>
        <BillingAddressListFSM
          {...props}
          handleOpenAddress={handleOpenAddress}
          handleClose={handleClose}
          handleAddNewAddress={handleAddNewAddress}
        />
      </Dialog>
    );
  }

  return (
    <Dialog height={770} width={520} onClose={handleClose}>
      <BillingFormFullscreenFSM
        {...props}
        handleClose={handleClose}
        hideDeleteButton={!!bootstrapConfig.externalAddressBookProvider}
        extendedAddress={extendedAddress}
        setExtendedAddress={setExtendedAddress}
      />
    </Dialog>
  );
};

BillingFormModal.fullscreenName = 'BillingFormModal';

export const BillingFormModalProxy: React.FC<BillingFormModalProps> = props => {
  return (
    <FullscreenMode>
      <BillingFormModal {...props} />
    </FullscreenMode>
  );
};
